module.exports = __webpack_public_path__ + "img/theme7.a3b17691.png";